
const API_URL = process.env.NODE_ENV === 'production' ? window.env.REACT_APP_API_END_POINT : process.env.REACT_APP_API_END_POINT;
export default API_URL
